import ExtensionModel from './ExtensionModel';
import UserCourseModel from './UserCourseModel';
import moment from 'moment';


class CourseElementModel extends ExtensionModel {

	public course:UserCourseModel;
	
	constructor( model:Object ) {
		super( model );
	}
	
	get modelName():string {
		return this.get<string>( 'modelName' );
	}

	get id():number{
		return this.get<number>( 'id' );	
	}

	get displayTime():string {
		
		var from = this.course.getPreviousElement( this ).endTime();
		return from + ' - ' + moment( <string> from, [ 'H:mm' ] ).add( <number> this.get( 'time' ), 'minutes' ).format( 'H:mm' );

	}

	public endTime():string {
		
		if( this.modelName == 'App\\Daybreak' || this.modelName == 'App\\DaybreakPreview' ){
			let from = moment( <string> this.get( 'time' ), [ 'H:mm' ] );
			return from.format( 'H:mm' );
		}
		let from = moment( this.course.getPreviousElement( this ).endTime(), ['H:m'] );
		let endtime = from.add( <number> this.get( 'time' ), 'minutes' );
		return endtime.format( 'H:mm' );
		
	}
	
}

export default CourseElementModel;